class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  normalizeSearchTerm(value) {
    return value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  getSynonymSearchTerm(value) {
    const term = this.normalizeSearchTerm(value);

    return term
      .replace(/\bpies?\s+de\s+cama\b/g, 'plaid')
      .replace(/\bpies?\s+cama\b/g, 'plaid')
      .replace(/\s+/g, ' ')
      .trim();
  }

  onFormSubmit() {
    if (!this.input || !this.input.form) return;

    const synonymTerm = this.getSynonymSearchTerm(this.input.value);
    const currentTerm = this.normalizeSearchTerm(this.input.value);

    if (synonymTerm && synonymTerm !== currentTerm) {
      this.input.value = synonymTerm;
      this.ensureProductSearchScope();
    }
  }

  ensureProductSearchScope() {
    if (this.input.form.querySelector('input[name="type"]')) return;

    const productSearchScope = document.createElement('input');
    productSearchScope.type = 'hidden';
    productSearchScope.name = 'type';
    productSearchScope.value = 'product';
    this.input.form.appendChild(productSearchScope);
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
